
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 5a2 2 0 012-2h4.387a2 2 0 011.53.712l.784.932a1 1 0 00.765.356H18a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V5z","fill":"#26A469"}}),_c('path',{attrs:{"d":"M3 8a2 2 0 012-2h13a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V8z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.825 8.653A2.026 2.026 0 015.83 7h14.134c1.255 0 2.211 1.105 2.009 2.322l-1.964 10A2.025 2.025 0 0118 21H4.036c-1.265 0-2.224-1.122-2.005-2.347l1.794-10z","fill":"#30C07C"}})])
          )
        }
      }
    